import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { ImmagineFormType } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useImmagineCreate } from "../../hooks/immagini"
import ImmagineForm from "./ImmagineForm"
import { initialValuesImmagine, validationSchemaImmagine } from "./ImmagineCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function ImmagineCreate() {
  const createImmagine = useImmagineCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Immagini", href: "/edizioni/immagini" }, { label: "Creazione Immagine" }])

  const initialValues = useMemo(() => initialValuesImmagine(), [])
  const validationSchema = useMemo(() => validationSchemaImmagine(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova immagine</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createImmagine.mutateAsync(values as ImmagineFormType).then((immagine) => {
                navigate(`/edizioni/immagini/${immagine.id}`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ImmagineForm showEdizione />
                </Container>
                <BottomFormFixed url="/edizioni/immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
